export { default } from './TableItemImage'
